import { ResponsiveUiHelper }                  from '..';

/**
 * The service that provide easy access to theme configuration parameters encapsulating the origin, default 
 * values or the business logic related to the override hierarchy.
 */
export class ConfigThemeService {

   /** ***********************************  INITIALIZATION  ********************************** */

   public static initializeThemeVariables(vuetifyRef: any) {
      // override Vuetify theme colors if needed
      const configLightThemeColorPalette: any | null = ConfigThemeService.getLightThemeColorPalette();
      if (configLightThemeColorPalette) {
         if (configLightThemeColorPalette.base) { vuetifyRef.theme.themes.light.base = configLightThemeColorPalette.base; }
         if (configLightThemeColorPalette.main) { vuetifyRef.theme.themes.light.main = configLightThemeColorPalette.main; }
         if (configLightThemeColorPalette.info) { vuetifyRef.theme.themes.light.info = configLightThemeColorPalette.info; }
         if (configLightThemeColorPalette.primary) { vuetifyRef.theme.themes.light.primary = configLightThemeColorPalette.primary; }
         if (configLightThemeColorPalette.secondary) { vuetifyRef.theme.themes.light.secondary = configLightThemeColorPalette.secondary; }
         if (configLightThemeColorPalette.tertiary) { vuetifyRef.theme.themes.light.tertiary = configLightThemeColorPalette.tertiary; }
         if (configLightThemeColorPalette.accent) { vuetifyRef.theme.themes.light.accent = configLightThemeColorPalette.accent; }
         if (configLightThemeColorPalette.warning) { vuetifyRef.theme.themes.light.warning = configLightThemeColorPalette.warning; }
         if (configLightThemeColorPalette.error) { vuetifyRef.theme.themes.light.error = configLightThemeColorPalette.error; }
         if (configLightThemeColorPalette.disabled) { vuetifyRef.theme.themes.light.disabled = configLightThemeColorPalette.disabled; }
      }
      // override Vuetify theme colors if needed
      const configDarkThemeColorPalette: any | null = ConfigThemeService.getDarkThemeColorPalette();
      if (configDarkThemeColorPalette) {
         if (configDarkThemeColorPalette.base) { vuetifyRef.theme.themes.dark.base = configDarkThemeColorPalette.base; }
         if (configDarkThemeColorPalette.main) { vuetifyRef.theme.themes.dark.main = configDarkThemeColorPalette.main; }
         if (configDarkThemeColorPalette.info) { vuetifyRef.theme.themes.dark.info = configDarkThemeColorPalette.info; }
         if (configDarkThemeColorPalette.primary) { vuetifyRef.theme.themes.dark.primary = configDarkThemeColorPalette.primary; }
         if (configDarkThemeColorPalette.secondary) { vuetifyRef.theme.themes.dark.secondary = configDarkThemeColorPalette.secondary; }
         if (configDarkThemeColorPalette.tertiary) { vuetifyRef.theme.themes.dark.tertiary = configDarkThemeColorPalette.tertiary; }
         if (configDarkThemeColorPalette.accent) { vuetifyRef.theme.themes.dark.accent = configDarkThemeColorPalette.accent; }
         if (configDarkThemeColorPalette.warning) { vuetifyRef.theme.themes.dark.warning = configDarkThemeColorPalette.warning; }
         if (configDarkThemeColorPalette.error) { vuetifyRef.theme.themes.dark.error = configDarkThemeColorPalette.error; }
         if (configDarkThemeColorPalette.disabled) { vuetifyRef.theme.themes.dark.disabled = configDarkThemeColorPalette.disabled; }
      }
   }

   /** *************************************  APPLIED THEMES ************************************* */

   public static getDefaultTheme(): string {
     return (window.botSettings && window.botSettings.customChatbotTheme 
                                && window.botSettings.customChatbotTheme.appliedTheme)
                                 ? window.botSettings.customChatbotTheme.appliedTheme.all : 'light';
   }

   public static getHeaderAppliedTheme(): any {
      const defaultTheme: any = ConfigThemeService.getDefaultTheme();
      const configTheme: any | undefined = (window.botSettings && window.botSettings.customChatbotTheme 
                                                               && window.botSettings.customChatbotTheme.appliedTheme)
                                                                ? window.botSettings.customChatbotTheme.appliedTheme.header : defaultTheme;
      return configTheme ? configTheme : defaultTheme;
   }

   public static getUserMessageBoxAppliedTheme(): any {
      const defaultTheme: any = ConfigThemeService.getDefaultTheme();
      const configTheme: any | undefined = (window.botSettings && window.botSettings.customChatbotTheme 
                                                               && window.botSettings.customChatbotTheme.appliedTheme)
                                                                ? window.botSettings.customChatbotTheme.appliedTheme.userMsgBox : defaultTheme;
      return configTheme ? configTheme : defaultTheme;
   }

   public static getBotMessageBoxAppliedTheme(): any {
      const defaultTheme: any = ConfigThemeService.getDefaultTheme();
      const configTheme: any | undefined = (window.botSettings && window.botSettings.customChatbotTheme 
                                                               && window.botSettings.customChatbotTheme.appliedTheme)
                                                                ? window.botSettings.customChatbotTheme.appliedTheme.botMsgBox : defaultTheme;
      return configTheme ? configTheme : defaultTheme;
   }

   public static getBotMessageAnchorsAppliedTheme(): any {
      const defaultTheme: any = ConfigThemeService.getDefaultTheme();
      const configTheme: any | undefined = (window.botSettings && window.botSettings.customChatbotTheme 
                                                               && window.botSettings.customChatbotTheme.appliedTheme)
                                                                ? window.botSettings.customChatbotTheme.appliedTheme.botMsgLinks : defaultTheme;
      return configTheme ? configTheme : defaultTheme;
   }

   /** *****************************************  IMAGES ***************************************** */

   public static getHeaderBackgroundImg() : any | undefined {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.backgroundImgs 
                                 && window.botSettings.customChatbotTheme.backgroundImgs.header)
                                  ? window.botSettings.customChatbotTheme.backgroundImgs.header : undefined;
   }

   public static getConversationPanelBackgroundImg() : any | undefined {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.backgroundImgs 
                                 && window.botSettings.customChatbotTheme.backgroundImgs.conversationPanel)
                                  ? window.botSettings.customChatbotTheme.backgroundImgs.conversationPanel : undefined;
   }

   public static getHeaderBackgroundImgGradient() : any | undefined {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.backgroundImgs 
                                 && window.botSettings.customChatbotTheme.backgroundImgs.header)
                                  ? window.botSettings.customChatbotTheme.backgroundImgs.header.gradient : undefined;
   }

   /** *****************************************  ICONS  ***************************************** */

   public static getSettingsIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.settings)
                                  ? window.botSettings.customChatbotTheme.icons.settings : 'mdi-cog';
   }

   public static getDeleteConversationIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.deleteConversation)
                                  ? window.botSettings.customChatbotTheme.icons.deleteConversation : 'mdi-trash-can-outline';
   }

   public static getGoToStartOfConversationIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.goToStartOfConversation)
                                  ? window.botSettings.customChatbotTheme.icons.goToStartOfConversation : 'mdi-arrow-up-bold-circle';
   }

   public static getSendIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.typerSend)
                                  ? window.botSettings.customChatbotTheme.icons.typerSend : 'mdi-send';
   }

   public static getHeaderHideConversationPanelIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.hideMainPanel)
                                  ? window.botSettings.customChatbotTheme.icons.hideMainPanel : 'mdi-window-close';
   }

   public static getLeftNavigationIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                && window.botSettings.customChatbotTheme.icons
                                && window.botSettings.customChatbotTheme.icons.leftNavigation)
                                ? window.botSettings.customChatbotTheme.icons.leftNavigation : 'mdi-arrow-left';
   }

   public static getRightNavigationIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.rightNavigation)
                                  ? window.botSettings.customChatbotTheme.icons.rightNavigation : 'mdi-arrow-right';
   }

   public static getClosePopupPanelIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.hidePopupPanel)
                                  ? window.botSettings.customChatbotTheme.icons.hidePopupPanel : 'mdi-window-close';
   }

   public static getCloseDrawerPanelIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.hideDrawerPanel)
                                  ? window.botSettings.customChatbotTheme.icons.hideDrawerPanel : 'mdi-exit-to-app';
   }

   public static getMessageBoxPlaceholderIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.msgTablePlaceholder)
                                  ? window.botSettings.customChatbotTheme.icons.msgTablePlaceholder : 'mdi-message-bulleted';
   }

   public static getCopyButtonIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.copyButtonIcon)
                                  ? window.botSettings.customChatbotTheme.icons.copyButtonIcon : 'mdi-content-copy';
   }

   public static getSatisfactionButtonUpIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.satisfactionButtonUpIcon)
                                  ? window.botSettings.customChatbotTheme.icons.satisfactionButtonUpIcon : 'mdi-thumb-up';
   }

   public static getSatisfactionButtonDownIcon() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.satisfactionButtonDownIcon)
                                  ? window.botSettings.customChatbotTheme.icons.satisfactionButtonDownIcon : 'mdi-thumb-down';
   }

   public static getIconReducedAvatar() : any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.icons
                                 && window.botSettings.customChatbotTheme.icons.reducedAvatarIcon)
                                  ? window.botSettings.customChatbotTheme.icons.reducedAvatarIcon : 'mdi-arrow-collapse';
   }

   /** *****************************************  SHAPES ***************************************** */
   
   /**
    * Possible values are : 
    *  - tile (filled and flat without elevation), 
    *  - raised (filled with elevation) and 
    *  - outlined (flat version with only colored border and transparent inside)
    */
   public static getUserMessageBoxShape(): any | undefined {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.shapes) 
                                  ? window.botSettings.customChatbotTheme.shapes.userMsgBox : 'tile';
   }

   /**
    * Possible values are : 
    *  - tile (filled and flat without elevation), 
    *  - raised (filled with elevation) and 
    *  - outlined (flat version with only colored border and transparent inside)
    */
   public static getBotMessageBoxShape(): any | undefined {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.shapes) 
                                  ? window.botSettings.customChatbotTheme.shapes.botMsgBox : 'tile';
   }

   /**
    * Possible values are : 
    *  - tile (filled with elevation with no rounded corners) the text have the 'base' color,
    *  - depressed (filled and flat with soft rounded corners) the text have the 'base' color and
    *  - outlined (flat version with only colored border and transparent inside) the text have the border color 
    */
   public static getMessageBoxButtonsShape(): any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.shapes)
                                  ? window.botSettings.customChatbotTheme.shapes.messageBoxButtons : 'outlined';
   }

   /**
    * Possible values are : 
    *  - tile (filled with elevation with no rounded corners) the text have the 'base' color,
    *  - rounded (filled and flat with soft rounded corners) the text have the 'base' color and
    *  - outlined (flat version with only colored border and transparent inside) the text have the border color 
    */
    public static getMessageBoxClarificationButtonsShape(): any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.shapes
                                 && window.botSettings.customChatbotTheme.shapes.clarificationButtons)
                                  ? window.botSettings.customChatbotTheme.shapes.clarificationButtons : 'rounded';
   }


   /**
    * Possible values are : 
    *  - tile (filled and flat with no rounded corners) the text have the 'base' color,
    *  - depressed (filled with elevation with soft rounded corners) the text have the 'base' color and
    *  - rounded (filled, rounded, with elevation) the text have the 'base' color,
    *  - outlined (flat version with only colored border and transparent inside) the text have the border color 
    */
   public static getPlaceholderButtonsShape(): any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.shapes)
                                  ? window.botSettings.customChatbotTheme.shapes.placeholderButtons 
                                  : ConfigThemeService.getMessageBoxButtonsShape();
   }

   /**
    * Possible values are : 
    *  - tile (filled and flat with no rounded corners) the text have the 'base' color,
    *  - depressed (filled with elevation with soft rounded corners) the text have the 'base' color and
    *  - rounded (filled, rounded, with elevation) the text have the 'base' color,
    *  - outlined (flat version with only colored border and transparent inside) the text have the border color 
    */
    public static getNotificationButtonShape(): any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.notification)
                                  ? window.botSettings.customChatbotTheme.notification.buttonShape 
                                  : ConfigThemeService.getMessageBoxButtonsShape();
   }

   /**
    * Possible values are : 
    *  - tile (filled and flat with no rounded corners) the text have the 'base' color,
    *  - depressed (filled with elevation with soft rounded corners) the text have the 'base' color and
    *  - rounded (filled, rounded, with elevation) the text have the 'base' color,
    *  - outlined (flat version with only colored border and transparent inside) the text have the border color 
    */
    public static getNotificationShape(): any {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.notification)
                                  ? window.botSettings.customChatbotTheme.notification.shape 
                                  : ConfigThemeService.getBotMessageBoxShape();
   }

   /** *****************************************  COLORS ***************************************** */

   public static getLightThemeColorPalette(): any | undefined {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.colors) 
                                  ? window.botSettings.customChatbotTheme.colors.lightTheme : undefined;
   }

   public static getDarkThemeColorPalette(): any | undefined {
      return (window.botSettings && window.botSettings.customChatbotTheme 
                                 && window.botSettings.customChatbotTheme.colors)
                                  ? window.botSettings.customChatbotTheme.colors.darkTheme : undefined;
   }

   public static getConversationPanelBackgroundColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.conversationPanel) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.conversationPanel : 'base !important';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.conversationPanel) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.conversationPanel : 'base !important'; 
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getUserMessageBoxColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.userMsgBox) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.userMsgBox : 'secondary';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.userMsgBox) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.userMsgBox : 'secondary'; 
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getBotMessageBoxColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.botMsgBox) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.botMsgBox : 'primary';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.botMsgBox) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.botMsgBox : 'primary'; 
      }

      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getBotMessageBoxTextColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.botMsgBoxText) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.botMsgBoxText : 'main';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.botMsgBoxText) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.botMsgBoxText : 'main'; 
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getUserMessageBoxTextColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.userMsgBoxText) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.userMsgBoxText : 'base';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.userMsgBoxText) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.userMsgBoxText : 'base'; 
      }

      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getBotBoxMessageKnowMoreLinkColor(vuetifyRef: any): string  {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.knowMoreLink) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.knowMoreLink : 'base';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.knowMoreLink) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.knowMoreLink : 'base'; 
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getBotBoxMessageBorderKnowMoreLinkColor(vuetifyRef: any): string  {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.boxMsgBorderKnowMoreLink ) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.boxMsgBorderKnowMoreLink  : 'base';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.boxMsgBorderKnowMoreLink ) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.boxMsgBorderKnowMoreLink  : 'base'; 
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getMessageBoxPlaceholderColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.msgTablePlaceholder) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.msgTablePlaceholder : 'tertiary';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.msgTablePlaceholder) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.msgTablePlaceholder : 'tertiary'; 
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getCopyButtonsColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.copyButton) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.copyButton : 'base';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.copyButton) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.copyButton : 'base'; 
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);                  
   }

   public static getCopyAlertColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.copyAlert) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.copyAlert : 'info';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.copyAlert) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.copyAlert : 'info'; 
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);                  
   }

   public static getSatisfactionButtonsColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.satisfactionButtons) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.satisfactionButtons : 'base';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.satisfactionButtons) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.satisfactionButtons : 'base'; 
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);                  
   }

   public static getClarificationButtonsColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.clarificationButtons) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.clarificationButtons : 'base';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.clarificationButtons) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.clarificationButtons : 'base'; 
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);                  
   }

   public static getMessageBoxSatisfactionQuestionsZoneColor(vuetifyRef: any): any {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.messageBoxSatQuestionZone) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.messageBoxSatQuestionZone 
                                            : `${ConfigThemeService.getBotMessageBoxColor(vuetifyRef)}`;
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.messageBoxSatQuestionZone) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.messageBoxSatQuestionZone 
                                            : `${ConfigThemeService.getBotMessageBoxColor(vuetifyRef)}`;
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getMessageBoxButtonsColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.messageBoxButtons) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.messageBoxButtons : 'tertiary';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.messageBoxButtons) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.messageBoxButtons : 'tertiary'; 
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getTruncateMsgElementColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.truncateMsgElement) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.truncateMsgElement 
                                            : ConfigThemeService.getBotMessageBoxShape() === 'outlined' ? ConfigThemeService.getBotMessageBoxColor(vuetifyRef) 
                                                                                                        : ConfigThemeService.getBotMessageBoxTextColor(vuetifyRef);
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.truncateMsgElement) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.truncateMsgElement 
                                            : ConfigThemeService.getBotMessageBoxShape() === 'outlined' ? ConfigThemeService.getBotMessageBoxColor(vuetifyRef) 
                                                                                                        : ConfigThemeService.getBotMessageBoxTextColor(vuetifyRef);
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getBotBoxMessageLinkColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.botMsgLinks) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.botMsgLinks : ConfigThemeService.getBotMessageBoxTextColor(vuetifyRef);
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.botMsgLinks) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.botMsgLinks : ConfigThemeService.getBotMessageBoxTextColor(vuetifyRef);
      }
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getLoadingAnimationColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.loadingAnimation) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.loadingAnimation : 'accent';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.loadingAnimation) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.loadingAnimation : 'accent';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getTyperColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.typer) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.typer : 'base';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.typer) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.typer : 'base';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getTyperSuggestionsColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.suggestionsList) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.suggestionsList : 'accent';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.suggestionsList) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.suggestionsList : 'accent';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getDeleteConversationColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.deleteConversation) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.deleteConversation : 'accent';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.deleteConversation) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.deleteConversation : 'accent';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getGoToStartOfConversationColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.goToStartOfConversation) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.goToStartOfConversation : 'accent';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.goToStartOfConversation) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.goToStartOfConversation : 'accent';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getSettingsPanelColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.settingsPanelColor) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.settingsPanelColor : 'grey darken-3';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.settingsPanelColor) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.settingsPanelColor : 'grey lighten-3';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getSettingsIconColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.settingsIconColor) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.settingsIconColor : 'accent';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.settingsIconColor) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.settingsIconColor : 'accent';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getTyperIconsColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.sendIcon) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.sendIcon : 'accent';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.sendIcon) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.sendIcon : 'accent';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getHeaderItemsColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.headerContent) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.headerContent : 'info';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.headerContent) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.headerContent : 'info';
      }
      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getCollapsedHeaderItemsColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.headerContent) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.headerContent : 'base';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.headerContent) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.headerContent : 'base';
      }
      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getHeaderColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.header) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.header : 'primary';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.header) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.header : 'primary';
      }
      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getFeedbackComponentColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.feedbackBanner) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.feedbackBanner : 'accent';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.feedbackBanner) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.feedbackBanner : 'accent';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getFeedbackTextColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.feedbackText) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.feedbackText : 'base';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.feedbackText) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.feedbackText : 'base';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getDrawerCloseIconColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.drawerCloseIcon) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.drawerCloseIcon : 'info';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.drawerCloseIcon) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.drawerCloseIcon : 'main';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getDrawerIconsColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.drawerIcons) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.drawerIcons : 'info';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.drawerIcons) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.drawerIcons : 'base';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getDrawerIconsBgColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.drawerIconsBg) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.drawerIconsBg : 'rgba(170, 170, 170, 0.65) !important';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.drawerIconsBg) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.drawerIconsBg : 'rgba(189, 189, 189, 0.2) !important';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getDrawerPanelBgColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.drawerPanelBg) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.drawerPanelBg : 'rgba(22, 22, 22, 0.9) !important';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.drawerPanelBg) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.drawerPanelBg : 'rgba(170, 170, 170, 0.65) !important';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getPopupIconsColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.popupIcons) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.popupIcons : 'info';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.popupIcons) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.popupIcons : 'base';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getPopupIconsBgColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.popupIconsBg) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.popupIconsBg : 'rgba(189, 189, 189, 0.2) !important';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.popupIconsBg) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.popupIconsBg : 'rgba(189, 189, 189, 0.2) !important';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getPopupPanelBgColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.popupPanelBg) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.popupPanelBg : 'rgba(22, 22, 22, 0.9) !important';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.popupPanelBg) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.popupPanelBg : 'rgba(170, 170, 170, 0.65) !important';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getScrollbarColor(vuetifyRef: any) {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.scrollbar) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.scrollbar : '#2e2d2d';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.scrollbar) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.scrollbar : '#2e2d2d';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getBotWelcomeBannerColor(vuetifyRef: any): any {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.welcomeBanner) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.welcomeBanner : 'info';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.welcomeBanner) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.welcomeBanner : 'info';
      }
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   public static getNotificationBadgeColor(vuetifyRef: any): any {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.notificationBadgeColor) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.notificationBadgeColor : 'red';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.notificationBadgeColor) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.notificationBadgeColor : 'red';
      }
     return configColor;

   }

   public static getNotificationFontColor(vuetifyRef: any): any {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.notificationFontColor) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.notificationFontColor : 'white';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.notificationFontColor) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.notificationFontColor : 'white';
      }
      return configColor;
   }

   public static getQuoteLinkTextColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.quoteLinkText) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.quoteLinkText : 'black';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.quoteLinkText) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.quoteLinkText : 'black';
      }
      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }
   
   public static getQuoteLinkUnderlineColor(vuetifyRef: any): string {
      let configColor: string = '';
      if (vuetifyRef.theme.dark) {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme 
                                           && window.botSettings.customChatbotTheme.colors.darkTheme.quoteLinkUnderline) 
                                            ? window.botSettings.customChatbotTheme.colors.darkTheme.quoteLinkUnderline : 'accent';
      } else {
         configColor = (window.botSettings && window.botSettings.customChatbotTheme 
                                           && window.botSettings.customChatbotTheme.colors 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme 
                                           && window.botSettings.customChatbotTheme.colors.lightTheme.quoteLinkUnderline) 
                                            ? window.botSettings.customChatbotTheme.colors.lightTheme.quoteLinkUnderline : 'accent';
      }
      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, appliedTheme, configColor);
   }

   /** *************************************    ANIMATIONS    *********************************** */

   public static isActivatedScrollHeaderEffect(): boolean {
      const configAnimation: boolean = (window.botSettings && window.botSettings.customChatbotTheme 
                                                           && window.botSettings.customChatbotTheme.animations
                                                           && window.botSettings.customChatbotTheme.animations.headerCollapse) 
                                                            ? window.botSettings.customChatbotTheme.animations.headerCollapse : false;
      return configAnimation;
   }

   public static getWelcomeAvatarAnimation(): string {
      const configAnimation: string = (window.botSettings && window.botSettings.customChatbotTheme 
                                                          && window.botSettings.customChatbotTheme.animations
                                                          && window.botSettings.customChatbotTheme.animations.welcomeAvatar)
                                                          ? window.botSettings.customChatbotTheme.animations.welcomeAvatar : 'slide bounce';
      return configAnimation;
   }

   public static getChatboxPanelAnimation(): string {
      const configAnimation: string = (window.botSettings && window.botSettings.customChatbotTheme 
                                                          && window.botSettings.customChatbotTheme.animations
                                                          && window.botSettings.customChatbotTheme.animations.conversationPanel)
                                                           ? window.botSettings.customChatbotTheme.animations.conversationPanel : 'fade';
      return configAnimation;
   }

   /** *************************************  SPECIFIC STYLES *********************************** */

   public static getEmbeddedModeStyles(vuetifyRef: any): any {
      const defaultStyles: any = { backgroundColor: 'transparent !important' };
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      const configStyles: any = (window.botSettings && window.botSettings.customChatbotTheme 
                                                    && window.botSettings.customChatbotTheme.styles 
                                                    && window.botSettings.customChatbotTheme.styles.embbededConversationPanel) 
                                                     ? window.botSettings.customChatbotTheme.styles.embbededConversationPanel : defaultStyles;
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }
   
   public static getFloatingModeStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  willChange: 'box-shadow',
                                    boxShadow: '0px 18px 1px -2px rgba(0, 0, 0, 0.84), 0px 18px 18px 0px rgba(0, 0, 0, 0.4), 0px 8px 12px 0px rgba(0, 0, 0, 0.25)'
                                 };

      if (ConfigThemeService.getConversationPanelBackgroundColor(vuetifyRef) && 
          ConfigThemeService.getConversationPanelBackgroundColor(vuetifyRef).indexOf('linear-gradient') !== -1) {
         defaultStyles.background = `${ConfigThemeService.getConversationPanelBackgroundColor(vuetifyRef)}`;
      } else {
         defaultStyles.backgroundColor = `${ConfigThemeService.getConversationPanelBackgroundColor(vuetifyRef)}`;
      }

      if (ConfigThemeService.getConversationPanelBackgroundImg() &&
          ConfigThemeService.getConversationPanelBackgroundImg().indexOf('http') !== -1) {
         defaultStyles.background = `url(${ConfigThemeService.getConversationPanelBackgroundImg()}) repeat`;
      }

      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.conversationPanel) 
                                                                                  ? window.botSettings.customChatbotTheme.styles.conversationPanel : {});
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getBotWelcomeBannerStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  color: ConfigThemeService.getBotWelcomeBannerColor(vuetifyRef),
                                    backgroundColor: 'primary',
                                    fontFamily: 'Roboto',
                                    marginRight: '20px'
                                 };

      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.welcomeBanner) 
                                                                                  ? window.botSettings.customChatbotTheme.styles.welcomeBanner : {});

      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getHeaderStyles(vuetifyRef: any): any {
      const defaultStyles: any = { backgroundColor: `${ConfigThemeService.getHeaderColor(vuetifyRef)} !important`,
                                   willChange: 'box-shadow',
                                   boxShadow: '0 0 5px 0 rgba(0,0,0, 0.3)' };
      
      const configStyles: any = (window.botSettings && window.botSettings.customChatbotTheme 
                                                    && window.botSettings.customChatbotTheme.styles 
                                                    && window.botSettings.customChatbotTheme.styles.header) 
                                                     ? window.botSettings.customChatbotTheme.styles.header : defaultStyles;

      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getCollapsedHeaderStyles(vuetifyRef: any): any {
      const defaultStyles: any = { backgroundColor: `${ConfigThemeService.getHeaderColor(vuetifyRef)} !important` };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.header) 
                                                                                  ? window.botSettings.customChatbotTheme.styles.header : {});

      configStyles.borderBottomLeftRadius= '0 !important';
      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getCollapsedHeaderContainerStyles(vuetifyRef: any): any {
      const defaultStyles: any = {};
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.header) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.header : {});

      configStyles.borderBottomLeftRadius= '0 !important';
      configStyles.borderBottomRightRadius= '0 !important';

      if (ConfigThemeService.getHeaderColor(vuetifyRef).indexOf('linear-gradient') !== -1) {
         defaultStyles.background = `${ConfigThemeService.getHeaderColor(vuetifyRef)} !important`;
      } else {
         defaultStyles.backgroundColor = `${ConfigThemeService.getHeaderColor(vuetifyRef)} !important`;
      }

      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getHeaderInnerContainerStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  fontWeight: '300',
                                    height: '100%',
                                    width: '100%'
                                 };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.headerInner) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.headerInner : {});

      if (ConfigThemeService.getCollapsedHeaderItemsColor(vuetifyRef).indexOf('linear-gradient') !== -1) {
         defaultStyles.color = 'base';
         defaultStyles.background = `${ConfigThemeService.getCollapsedHeaderItemsColor(vuetifyRef)} !important`;
      } else {
         defaultStyles.color = `${ConfigThemeService.getCollapsedHeaderItemsColor(vuetifyRef)} !important`;
         defaultStyles.backgroundColor = 'info !important';
      }

      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getHeaderDecorationBannerStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  backgroundColor: 'warning !important',
                                    height: '3px !important',
                                    width: '100%',
                                 };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.headerDecorationBanner) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.headerDecorationBanner : { display: 'none' });
      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getHeaderIconsStyles(vuetifyRef: any): any {
      const defaultStyles: any = { fontWeight: '300' };
      const configStyles: any = (window.botSettings && window.botSettings.customChatbotTheme 
                                                    && window.botSettings.customChatbotTheme.styles 
                                                    && window.botSettings.customChatbotTheme.styles.headerIcons) 
                                                     ? window.botSettings.customChatbotTheme.styles.headerIcons : defaultStyles;

      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getPresentationAvatarStyles(vuetifyRef: any): any {
      const defaultStyles: any = { padding: '16px', 
                                   height: 'auto', 
                                   width: 'auto' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.presentationAvatar) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.presentationAvatar : {});

      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }
   
   public static getSmallAvatarStyles(vuetifyRef: any): any {
      const defaultStyles: any = { padding: '16px', 
                                   height: 'auto', 
                                   width: 'auto' };      
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.smallAvatar) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.smallAvatar : {});

      const appliedTheme: string = ConfigThemeService.getHeaderAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getUserMessageBoxStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  borderRadius: '16px 16px 0 16px !important',
                                    fontWeight: '300' };

      if (ConfigThemeService.getUserMessageBoxShape() === 'outlined') {
         defaultStyles.backgroundColor = 'transparent !important';
         defaultStyles.color = ConfigThemeService.getUserMessageBoxTextColor(vuetifyRef);
         defaultStyles.borderColor = `${ConfigThemeService.getUserMessageBoxColor(vuetifyRef)} !important`;
         defaultStyles.borderWidth = '2px';
      } else {
         defaultStyles.backgroundColor = `${ConfigThemeService.getUserMessageBoxColor(vuetifyRef)} !important`;
         defaultStyles.color = ConfigThemeService.getUserMessageBoxTextColor(vuetifyRef);
      } 
      if (ConfigThemeService.getUserMessageBoxShape() === 'tile') {
         defaultStyles.fontWeight = ConfigThemeService.getDefaultTheme() === 'dark' ? '300' : '200';
      }
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.userMsgBox) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.userMsgBox : {});
      const appliedTheme: string = ConfigThemeService.getUserMessageBoxAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getBotMessageBoxStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  borderRadius: '16px 16px 16px 0 !important',
                                    fontWeight: '300',
                                    overflow: 'hidden',
                                 };
      if (ConfigThemeService.getBotMessageBoxShape() === 'outlined') {
         defaultStyles.backgroundColor = 'base !important';
         defaultStyles.color = ConfigThemeService.getBotMessageBoxTextColor(vuetifyRef);
         defaultStyles.borderColor = `${ConfigThemeService.getBotMessageBoxColor(vuetifyRef)} !important`;
         defaultStyles.borderWidth = '2.4px';
      } else {
         defaultStyles.backgroundColor = ConfigThemeService.getBotMessageBoxColor(vuetifyRef);
         defaultStyles.color = ConfigThemeService.getBotMessageBoxTextColor(vuetifyRef);
      }
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.botMsgBox) 
                                                                                 ?  window.botSettings.customChatbotTheme.styles.botMsgBox : {});
      
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }


   public static getBotMessageNotificationStyles(vuetifyRef: any): any {

      if(window.botSettings && window.botSettings.customChatbotTheme 
                            && window.botSettings.customChatbotTheme.notification 
                            && window.botSettings.customChatbotTheme.notification.style){

         const defaultStyles: any = {  borderRadius: '16px 16px 16px 0 !important',
            fontWeight: '300',
            overflow: 'hidden',
            backgroundColor : 'transparent',
            borderColor: 'transparent',
         };

         const configStyles: any = Object.assign(defaultStyles, window.botSettings.customChatbotTheme.notification.style);

         const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
         return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
      } else {
         return this.getBotMessageBoxStyles(vuetifyRef);
      }     
   }

   public static getMessageBoxSatQuestionStyles(vuetifyRef: any): any {
      const defaultStyles: any = { minHeight: '42px' };

      if (ConfigThemeService.getBotMessageBoxShape() === 'outlined') {
         defaultStyles.backgroundColor = ConfigThemeService.getMessageBoxSatisfactionQuestionsZoneColor(vuetifyRef);
         defaultStyles.color = (defaultStyles.backgroundColor.indexOf('transparent') > -1) ? ConfigThemeService.getBotMessageBoxTextColor(vuetifyRef) 
                                                                                           : ConfigThemeService.getClarificationButtonsColor(vuetifyRef); 
      } else {
         defaultStyles.backgroundColor = 'accent';
         defaultStyles.color = ConfigThemeService.getClarificationButtonsColor(vuetifyRef);
      } 

      if (defaultStyles.color === '') {
         defaultStyles.color = 'base !important';
      }

      const configStyles: any = (window.botSettings && window.botSettings.customChatbotTheme 
                                                    && window.botSettings.customChatbotTheme.styles 
                                                    && window.botSettings.customChatbotTheme.styles.messageBoxSatQuestionZone) 
                                                     ? window.botSettings.customChatbotTheme.styles.messageBoxSatQuestionZone : defaultStyles;                                    
      
      const appliedTheme: string = ConfigThemeService.getBotMessageBoxAppliedTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getMessageBoxButtonsStyles(vuetifyRef: any): any {
      const defaultStyles: any = { height: 'auto',
                                   minHeight: '40px',
                                   fontSize: 'inherit'
                                 };
      if (ConfigThemeService.getMessageBoxButtonsShape() === 'outlined') {
         defaultStyles.backgroundColor = 'transparent !important';
         defaultStyles.color = ConfigThemeService.getMessageBoxButtonsColor(vuetifyRef);
         defaultStyles.borderColor = `${ConfigThemeService.getMessageBoxButtonsColor(vuetifyRef)} !important`;
         defaultStyles.borderWidth = '2px';
         defaultStyles.borderStyle = 'solid';
      } else {
         defaultStyles.backgroundColor = 'tertiary !important';
         defaultStyles.color = 'base';
      }
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles
                                                                                 && window.botSettings.customChatbotTheme.styles.messageBoxButtons) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.messageBoxButtons : {});
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getBotMessageNotificationButtonsStyles(vuetifyRef: any): any {

      if(window.botSettings && window.botSettings.customChatbotTheme 
                              && window.botSettings.customChatbotTheme.notification
                              && window.botSettings.customChatbotTheme.notification.buttonsStyle){

         const defaultStyles: any = { height: 'auto',
            minHeight: '40px',
            fontSize: 'inherit'
         };

         const configStyles: any = Object.assign(defaultStyles, window.botSettings.customChatbotTheme.notification.buttonsStyle);
         const appliedTheme: string = ConfigThemeService.getDefaultTheme();
         return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
      } 
      else {
         return this.getMessageBoxButtonsStyles(vuetifyRef);
      }
      
   }

   public static getMessageBoxButtonsDisabledStyles(vuetifyRef: any): any {
      const defaultStyles: any = { color: 'disabled !important',
                                   borderColor: 'disabled !important',
                                   fontSize: 'inherit',
                                   fontWeight: '400',
                                   height: 'auto',
                                   minHeight: '35px'
                                 };
      const configStyles: any = (window.botSettings && window.botSettings.customChatbotTheme 
                                                    && window.botSettings.customChatbotTheme.styles
                                                    && window.botSettings.customChatbotTheme.styles.messageBoxDisabledButtons) 
                                                     ? window.botSettings.customChatbotTheme.styles.messageBoxDisabledButtons : defaultStyles;
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getCopyButtonsStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  };

      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.copyButton) 
                                                                                  ? window.botSettings.customChatbotTheme.styles.copyButton : {});
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getSatisfactionButtonsStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  };

      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.satisfactionButtons) 
                                                                                  ? window.botSettings.customChatbotTheme.styles.satisfactionButtons : {});
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getInsatisfactionClarificationIntroStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  height: 'auto',
                                    fontWeight: '300',
                                    minHeight: '30px' };
                        
      defaultStyles.color = ConfigThemeService.getBotBoxMessageBorderKnowMoreLinkColor(vuetifyRef);
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.clarificationIntro) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.clarificationIntro : {});
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getInsatisfactionClarificationButtonsStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  height: 'auto',
                                    fontWeight: '300',
                                    minHeight: '30px' };
                        
      if (ConfigThemeService.getMessageBoxClarificationButtonsShape() !== 'outlined') {
         defaultStyles.color = 'base';
      }

      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.clarificationButtons) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.clarificationButtons : {});
      
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);

      if (ConfigThemeService.getClarificationButtonsColor(vuetifyRef) === configStyles.color) {
         configStyles.color = 'main';
         ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
      }
      return configStyles;
   }

   public static getBotBoxMessageKnowMoreLinkStyles(vuetifyRef: any): any  {
      const configStyles: any = {   color: ConfigThemeService.getBotBoxMessageBorderKnowMoreLinkColor(vuetifyRef) + ' !important',
                                    fontSize: '90%',
                                    fontWeight: '600',
                                    fontStyle: 'italic',
                                    textDecoration: 'none',
                                    paddingTop: '4px',
                                    marginRight: 'auto !important' };
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getTruncateNonUnfoldableLinkStyles(vuetifyRef: any): any {
      const configStyles: any = {   color: ConfigThemeService.getTruncateMsgElementColor(vuetifyRef),
                                    fontSize: '95%',
                                    fontWeight: '700',
                                    fontStyle: 'italic',
                                    textDecoration: 'none',
                                    paddingTop: '4px',
                                    marginRight: 'auto !important' };
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getTruncateUnfoldableLinkStyles(vuetifyRef: any): any {
      const configStyles: any = {   color: ConfigThemeService.getTruncateMsgElementColor(vuetifyRef),
                                    paddingBottom: '4px' };
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getTyperStyles(vuetifyRef: any): any {
      const defaultStyles: any = {  borderWidth: '1px',
                                    borderColor: 'disabled', 
                                    borderStyle: 'solid', 
                                    marginBottom: '32px !important' 
                                 };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.typer) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.typer : {});
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getDrawerStyles(vuetifyRef: any): any {
      const defaultStyles: any = { backgroundColor: ConfigThemeService.getDrawerPanelBgColor(vuetifyRef) };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.drawer) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.drawer : {});
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getPopupStyles(vuetifyRef: any): any {
      const defaultStyles: any = { backgroundColor: ConfigThemeService.getPopupPanelBgColor(vuetifyRef) };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.popup) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.popup : {});
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   public static getNotificationBoxStyle(vuetifyRef: any): any{
      const {customChatbotTheme} = window.botSettings
      const defaultStyle = {
         carrouselCycleTimeMs : 10000,  
      }
      if(customChatbotTheme && customChatbotTheme.styles.notificationBox ){
         return customChatbotTheme.styles.notificationBox
      }
      return defaultStyle
   }

   public static getMessageBoxPlaceholderButtonStyles(vuetifyRef: any): any {
      const defaultStyles: any = { backgroundColor: 'transparent !important' };
      if (ConfigThemeService.getPlaceholderButtonsShape() === 'outlined') {
         defaultStyles.color = 'tertiary';
         defaultStyles.borderColor = 'tertiary';
         defaultStyles.borderWidth = '1px';
         defaultStyles.borderStyle = 'solid';
      } else {
         defaultStyles.color = 'base !important';
         defaultStyles.backgroundColor = 'tertiary !important';
      }
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.placeholderButtons) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.placeholderButtons : {});
      const appliedTheme: string = ConfigThemeService.getDefaultTheme();
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, appliedTheme, configStyles);
   }

   /** ***********************************  COMPUTED STYLES ********************************** */

   public static getHeaderMinHeight(): string {
      const defaultStyles: any = { 
                                    minHeight: '100' 
                                 };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.header 
                                                                                 && window.botSettings.customChatbotTheme.styles.header.minHeight) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.header : {});
      return configStyles.minHeight;
   }

   public static getHeaderMaxTextHeight(): string {
      const defaultStyles: any = { 
                                    maxTextHeight: '300' 
                                 };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.header 
                                                                                 && window.botSettings.customChatbotTheme.styles.header.maxTextHeight) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.header : {});
      return configStyles.maxTextHeight;
   }

   public static getPresentationAvatarHeight(): string {
      const defaultStyles: any = { height: '180' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.presentationAvatar 
                                                                                 && window.botSettings.customChatbotTheme.styles.presentationAvatar.height) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.presentationAvatar : {});
      return configStyles.height;
   }

   public static getPresentationAvatarWidth(): string {
      const defaultStyles: any = { width: '140' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.presentationAvatar 
                                                                                 && window.botSettings.customChatbotTheme.styles.presentationAvatar.width) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.presentationAvatar : {});
      return configStyles.width;
   }

   public static getPresentationAvatarMargin(): string {
      const defaultStyles: any = { margin: '16' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.presentationAvatar 
                                                                                 && window.botSettings.customChatbotTheme.styles.presentationAvatar.margin) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.presentationAvatar : {});
      return configStyles.margin;
   }

   public static getWelcomeBannerPadding(): string {
      const defaultStyles: any = { padding: '8' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.welcomeBanner 
                                                                                 && window.botSettings.customChatbotTheme.styles.welcomeBanner.padding) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.welcomeBanner : {});
      return configStyles.padding;
   }

   public static getSmallVersionAvatarWidth(): string {
      const defaultStyles: any = { width: '70' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.smallAvatar 
                                                                                 && window.botSettings.customChatbotTheme.styles.smallAvatar.width) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.smallAvatar : {});
      return configStyles.width;
   }

   public static getTyperHeight(): string {
      const defaultStyles: any = { height: '60' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.typer 
                                                                                 && window.botSettings.customChatbotTheme.styles.typer.height) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.typer : {});
      return configStyles.height;
   }

   public static getFeedbackHeight(): string {
      const defaultStyles: any = { height: '40' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.feedbackBanner 
                                                                                 && window.botSettings.customChatbotTheme.styles.feedbackBanner.height) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.feedbackBanner : {});
      return configStyles.height;
   }

   public static getNotificationBadgeLeft(): string {
      const defaultStyles: any = { left: '-125' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.notificationBadge 
                                                                                 && window.botSettings.customChatbotTheme.styles.notificationBadge.left) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.notificationBadge : {});
      return configStyles.left;
   }

   public static getNotificationBadgeTop(): string {
      const defaultStyles: any = { top: '50' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.notificationBadge 
                                                                                 && window.botSettings.customChatbotTheme.styles.notificationBadge.top) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.notificationBadge : {});
      return configStyles.top;
   }

   public static getSettingsMenuLeft(): string {
      const defaultStyles: any = { left: '22' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.settingsMenu 
                                                                                 && window.botSettings.customChatbotTheme.styles.settingsMenu.left) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.settingsMenu : {});
      return configStyles.left;
   }

   public static getSettingsMenuTop(): string {
      const defaultStyles: any = { top: '22' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles 
                                                                                 && window.botSettings.customChatbotTheme.styles.settingsMenu 
                                                                                 && window.botSettings.customChatbotTheme.styles.settingsMenu.top) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.settingsMenu : {});
      return configStyles.top;
   }

   public static getReducedRatio(): number {
      const defaultStyles: any = { reducedRatio: 0.7 };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles.reducedAvatar
                                                                                 && window.botSettings.customChatbotTheme.styles.reducedAvatar.reducedRatio) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.reducedAvatar : {});
      return configStyles.reducedRatio;
   }

   public static getReducedIconTopMargin(): string {
      const defaultStyles: any = { top: '10px' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles.reducedAvatar 
                                                                                 && window.botSettings.customChatbotTheme.styles.reducedAvatar.top) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.reducedAvatar : {});
      return configStyles.top;
   }

   public static getReducedIconRightMargin(): string {
      const defaultStyles: any = { right: '50px' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles.reducedAvatar 
                                                                                 && window.botSettings.customChatbotTheme.styles.reducedAvatar.right) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.reducedAvatar : {});
      return configStyles.right;
   }

   public static getReducedPlatform(): string {
      const defaultStyles: any = { platform: 'all' };
      const configStyles: any = Object.assign(defaultStyles, (window.botSettings && window.botSettings.customChatbotTheme 
                                                                                 && window.botSettings.customChatbotTheme.styles.reducedAvatar 
                                                                                 && window.botSettings.customChatbotTheme.styles.reducedAvatar.platform) 
                                                                                 ? window.botSettings.customChatbotTheme.styles.reducedAvatar : {});
      return configStyles.platform;
   }
}
